import axios from '../axiosApi';
import {
    FETCH_RASPA_ALARM_USAGE_STATISTICS,

    FETCH_RASPA_ALARMS,
    NEW_RASPA_ALARM,
    NEW_RASPA_ALARM_SUCCESS, RECEIVE_RASPA_ALARM_USAGE_STATISTICS,
    RECEIVE_RASPA_ALARMS
} from "./actionTypes";
import {fetchLoginLogouts, receiveLoginLogouts} from "./i4Actions";

export const fetchRaspaAlarms =  () => ({
    type: FETCH_RASPA_ALARMS
});

export const receiveRaspaAlarms = payload => ({
    type: RECEIVE_RASPA_ALARMS,
    payload: payload
});

export const dpnewRaspaAlarm =  () => ({
    type: NEW_RASPA_ALARM
});

export const dpnewRaspaAlarmSuccess = payload => ({
    type: NEW_RASPA_ALARM_SUCCESS,
    payload: payload
});

export const dpFetchRaspaAlarmUsageStatistics = () => ({
    type: FETCH_RASPA_ALARM_USAGE_STATISTICS,
    payload: {
        countUsage: []
    }
});

export const dpReceiveRaspaAlarmUsageStatistics = payload => ({
    type: RECEIVE_RASPA_ALARM_USAGE_STATISTICS,
    payload: payload
});


export const getRaspaAlarms = () => {
    return async dispatch => {
        dispatch(fetchRaspaAlarms());
        let payload;
        try {
            const response = await axios.get(`/RaspaAlarms`)
            payload = response.data
        }
        catch(e) {
            payload = { error: true };
        }
        finally {
            dispatch(receiveRaspaAlarms(payload));
        }
    }
};

export const newRaspaAlarm = (raspaRecipe) => {
    return async dispatch => {
        dispatch(dpnewRaspaAlarm());
        let payload;
        try {
            const response = await axios.post(`/RaspaAlarms`, raspaRecipe)
            payload = response.data
        }
        catch(e) {
            payload = { error: true };
        }
        finally {

            dispatch(dpnewRaspaAlarmSuccess(payload));
        }
    }
}

export const getRaspaAlarmes = () => {
    return async (dispatch,getState) => {
        dispatch(fetchRaspaAlarms());
        let payload;
        try {
            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate().toString().padStart(2,'0')

            const { periodMin, periodMax } = getState().filter;

            let url = `/raspa-alarmes?filter={"where":{ "data" : { "between": ["${periodMin}","${periodMax}"] }   }  }`;
            console.log("raspaAlarmes", url);
            const response = await axios.get(url)
            console.log(response.data);
            payload =  {
                alarmes: response.data
            }
        }
        catch(e) {
            payload = { error: true, message: e };
        }
        finally {
            dispatch(receiveRaspaAlarms(payload));
        }
    }
}

export const getRaspaAlarmUsageStatistics = () => {
    return async (dispatch, getState) => {
        dispatch(dpFetchRaspaAlarmUsageStatistics());

        let countUsage;
        let recipeUsage;
        let sideCorrectionUsage;

        let payload;

        const { periodMin, periodMax, beforeperiodMin, beforeperiodMax, benchperiodMin, benchperiodMax } = getState().filter;

        try {
            let options1 = {
                "Interval": {
                    "Min": periodMin,
                    "Max": periodMax
                },
                "IntervalComparasion": {
                    "Min": beforeperiodMin,
                    "Max": beforeperiodMax
                },
                "IntervalBenchmark": {
                    "Min": benchperiodMin,
                    "Max": benchperiodMax
                }
            }
            const response1 = await axios.post(`/raspaalarms/CountUsage`, options1)
            countUsage = response1.data;




        }
        catch(e) {
            payload = { error: true };
        }
        finally {

            payload = {
                countUsage: countUsage,

            }

            dispatch(dpReceiveRaspaAlarmUsageStatistics(payload));
        }
    }
}